/*
 * Copyright (c) 2023. Collabro Limited
 */

import React from "react";
import FlightCell from "./FlightCell";
import OffshoreCell from "./OffshoreCell";
import OtherLocationCell from "./OtherLocationCell";
import WaitlistCell from "./WaitlistCell";
import NightShiftCell from "./NightShiftCell";
import ExclusionCell from "./ExclusionCell";
import UnknownCell from "./UnknownCell";
import { LayerModel } from "RosterData";

export interface CellProps {
  location?: string;
}

interface MovementCellProps {
  cellType: string;
  location: string;
  flightName: string | null;
  departureLocation: string | null;
  arrivalLocation: string | null;
  fromTo: string | null;
  multiple: boolean;
  start: boolean;
  layer1: LayerModel[] | null;
  end: boolean;
}

const MovementCell = (props: MovementCellProps) => {
  const decideCellToShow = () => {
    switch (props.cellType) {
      case "FL":
        return (
          <FlightCell
            location={props.location}
            flightName={props.flightName!}
            departureLocation={props.departureLocation!}
            arrivalLocation={props.arrivalLocation!}
          />
        );
      case "OF":
        return (
          <OffshoreCell
            location={props.location}
            multiple={props.multiple}
            start={props.start}
            end={props.end}
            layer1={props.layer1}
          />
        );
      case "OL":
        return (
          <OtherLocationCell
            location={props.location}
            multiple={props.multiple}
            start={props.start}
            end={props.end}
            layer1={props.layer1}
          />
        );
      case "WL":
        return (
          <WaitlistCell
            location={props.location}
            flightName={props.flightName!}
            departureLocation={props.departureLocation!}
            arrivalLocation={props.arrivalLocation!}
          />
        );
      case "NS":
        return (
          <NightShiftCell
            location={props.location}
            multiple={props.multiple}
            start={props.start}
            end={props.end}
            layer1={props.layer1}
          />
        );
      case "EX":
        return (
          <ExclusionCell
            location={props.location}
            multiple={props.multiple}
            start={props.start}
            end={props.end}
          />
        );
      case "NA":
        return <UnknownCell />;
      default:
        return <></>;
    }
  };

  const calculatePadding = () => {
    if (props.multiple) {
      if (props.start) {
        return "0 0 0 2px";
      } else if (props.end) {
        return "0 2px 0 0";
      } else {
        return "0";
      }
    } else {
      return "0 2px";
    }
  };

  return (
    <div
      style={{
        padding: calculatePadding(),
        width: "100%",
      }}
    >
      {decideCellToShow()}
    </div>
  );
};

export default MovementCell;
